import { render, staticRenderFns } from "./product-cover.vue?vue&type=template&id=0dfcc819&scoped=true&"
import script from "./product-cover.vue?vue&type=script&lang=js&"
export * from "./product-cover.vue?vue&type=script&lang=js&"
import style0 from "./product-cover.sass?vue&type=style&index=0&id=0dfcc819&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfcc819",
  null
  
)

export default component.exports